import { render, staticRenderFns } from "./appleReturn.vue?vue&type=template&id=0fe4823c&scoped=true"
import script from "./appleReturn.vue?vue&type=script&lang=js"
export * from "./appleReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4823c",
  null
  
)

export default component.exports